module.exports = __webpack_public_path__ + "static/media/noCategory.dedcf6dd.svg";